export enum OverviewState {
  Expanded = 'expanded',
  Collapsed = 'collapsed'
}

export enum ChevronState {
  Rotated = 'rotated',
  Default = 'default'
}
